import type * as ents from '@attain-apps/entities'

/** App requests and results keyed by zone ID. */
export interface State {
  readonly lookup: Readonly<
    Partial<Record<ents.core.admin.Zone.Id, State.Entry>>
  >
}

export namespace State {
  export const INITIAL: State = { lookup: {} }

  export type Entry = ExactlyOneOf<{
    data?: readonly ents.core.admin.App.ForUser[]
    isLoading?: boolean
    error?: Error
  }>
}
